import axiosInstance from '../Axios-Config/Axios-Config';
import { ErrorToast } from '../components/ToastComponent/ErrorToast';
const saveCardDetails = async (state: any) => {
  try {
    const { data }: any = await axiosInstance.post('save/user/card/details', state);
    if (data?.success && data?.success == true) {
      return data;
    } else {
      ErrorToast(data?.message);
      return false;
    }
  } catch (error: any) {
    ErrorToast(error.message);
    return false;
  }
};
export default saveCardDetails;
